import React from 'react';

const NotFound = () => (
  <div className="container-fluid">
    <div className="jumbotron">
      <div className="container">
        <h1 className="display-4">Page introuvable...</h1>
        <p className="lead">L'adresse que vous avez entrée est inexistante.</p>
      </div>
    </div>
  </div>
)

export default NotFound;